export default {"src":"/_next/static/media/cart.0ee027d7.svg","height":24,"width":23};